import forexTemplate from "@/feature/Forex/store/template";
import forexBuy from "@/feature/Forex/store/buy";
import forexDraft from "@/feature/Forex/store/draft";
import forexApproval from "@/feature/Forex/store/approval";
import { ModuleTree } from "vuex";
import { IStoreRootState } from "@/store/interface";
import { FOREX_TEMPLATE_MODULE_NAME } from "@/feature/Forex/store/template/constants";
import { FOREX_BUY_MODULE_NAME } from "@/feature/Forex/store/buy/constants";
import { FOREX_DRAFT_MODULE_NAME } from "@/feature/Forex/store/draft/constants";
import { FOREX_APPROVAL_MODULE_NAME } from "@/feature/Forex/store/approval/constants";

export default <ModuleTree<IStoreRootState>> {
	[FOREX_TEMPLATE_MODULE_NAME]: forexTemplate,
	[FOREX_BUY_MODULE_NAME]: forexBuy,
	[FOREX_DRAFT_MODULE_NAME]: forexDraft,
	[FOREX_APPROVAL_MODULE_NAME]: forexApproval,
}
